import { html } from 'lit';
import { JVElement } from '../../lib/base';
import { icon } from '../../lib/icons';
import { jvLogo } from '../../lib/logo';
import { NAV } from '../../lib/nav';
/**
 * Operator sidebar navigation. Mirrors the wireframe sidebar:
 * a vertical nav rail with logo, surface label, and nav items.
 */
export class JvSidebar extends JVElement {
    static { this.properties = {
        surface: { type: String },
        active: { type: String },
        displayName: { type: String },
    }; }
    getInitial() {
        const name = this.displayName || '';
        return name.charAt(0).toUpperCase() || '?';
    }
    render() {
        const nav = NAV[this.surface] || NAV.operator;
        return html `<aside class="flex flex-col h-screen sticky top-0 border-r border-jv-border bg-jv-surface w-[15rem] shrink-0">
      <!-- Logo area -->
      <div class="px-4 py-4 flex items-center gap-2.5 border-b border-jv-border">
        ${jvLogo()}
        <span class="text-xs font-semibold text-jv-ink-2 leading-tight">${nav.label}</span>
      </div>

      <!-- Nav items -->
      <nav class="flex-1 overflow-y-auto py-2 px-2">
        ${nav.items.map(({ href, label, icon: ic }) => html `<a
              href="#${href}"
              class="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition
              ${this.active === href
            ? 'bg-jv-primary-050 text-jv-primary'
            : 'text-jv-ink-2 hover:bg-jv-surface-2 hover:text-jv-ink'}"
            >
              ${icon(ic, 'text-[18px]')}${label}
            </a>`)}
      </nav>

      <!-- User pill -->
      <div class="border-t border-jv-border px-3 py-3">
        <div class="flex items-center gap-3">
          <span class="w-8 h-8 rounded-full bg-jv-accent-050 text-jv-accent-600 grid place-items-center font-bold text-sm"
                title="${this.displayName || ''}">
            ${this.getInitial()}
          </span>
          <span class="text-sm font-medium text-jv-ink truncate">${this.displayName || 'Operator'}</span>
        </div>
      </div>
    </aside>`;
    }
}
